import React, { MouseEventHandler } from 'react'

import Button from 'common/components/button'
import { Close as CloseIcon } from 'common/icons'

type ProgressStatus = 'active' | 'exception' | 'success' | 'normal'

type Props = {
  display: boolean
  message: string
  generationErrorCancel: Function
}

type State = {
  display: 'block' | 'none'
  status: boolean
  animationText?: string
  type?: ProgressStatus
  generationErrorCancel: MouseEventHandler<HTMLElement>
  buttonDisplay: string
  message?: string
}

class GenerationError extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      display: props.display ? 'block' : 'none',
      status: true,
      animationText: props.message,
      type: 'exception',
      generationErrorCancel: props.generationErrorCancel,
      buttonDisplay: 'block',
    }
    this.progressStatusBar = this.progressStatusBar.bind(this)
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.display !== this.props.display ||
      prevProps.message !== this.props.message
    ) {
      this.setState(
        {
          display: this.props.display ? 'block' : 'none',
          message: this.props.message,
        },
        () => {
          this.progressStatusBar()
        }
      )
    }
  }

  progressStatusBar() {
    const { status, message } = this.state
    if (!status) {
      this.setState(() => ({
        animationText: message,
        type: 'exception',
        buttonDisplay: 'block',
      }))
    }
  }

  render() {
    const {
      display,
      type,
      buttonDisplay,
      animationText,
      generationErrorCancel,
    } = this.state

    return (
      <div id="scheduler-animation" style={{ display }}>
        <div className="animation-wrap">
          <div className="animation-image">
            <CloseIcon
              isDefaultColor={false}
              size={12}
              className="text-red-400"
            />
          </div>
          <div className="animation-text">{animationText}</div>
          <div className="animation-progress-bar">
            <div className="updated-component w-full bg-coolGray-200 rounded-full overflow-hidden h-[15px]">
              <div
                className={`h-full w-full ${
                  type === 'exception'
                    ? 'bg-red-500'
                    : type === 'success'
                      ? 'bg-green-500'
                      : 'bg-maroon-400'
                }`}
              />
            </div>
          </div>
          <div
            className="animation-error-btn"
            style={{ display: buttonDisplay }}
          >
            <Button
              variant="primary"
              onClick={generationErrorCancel}
              data-cy="generation-error-ok-button"
              data-testid="generation-error-ok-button"
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default GenerationError
